import React, {useState} from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import Header from "componentsHomePage/Header/Header.js";
import Footer from "components/Footers/AdminFooter.js";
import HeaderLinks from "componentsHomePage/Header/HeaderLinks.js";
import Parallax from "componentsHomePage/Parallax/Parallax.js";

import GridContainer from "componentsHomePage/Grid/GridContainer.js";
import GridItem from "componentsHomePage/Grid/GridItem.js";
import { Button } from "reactstrap";

import styles from "../assets/jss/material-kit-react/views/landingPage.js";
import stylesSection from "../assets/jss/material-kit-react/views/landingPageSections/productStyle.js";
import MediaModal from "./MediaModal.js";

const useStyles = makeStyles(styles);
const useStylesSection = makeStyles(stylesSection);

import mediaFile from "./mediaFile.js";

function Bars(props) {
    const [media, setMedia] = useState(mediaFile.albufeira66);
    const [tittle, setTittle] = useState('');
    const [modal, setModal] = useState(false);

    const classes = useStyles();
    const classesSection = useStylesSection();

    const { ...rest } = props;

    const displayMedia = (tittle,house)=>{
        setModal(true)
        setTittle(tittle)
        setMedia(mediaFile[house])
    }

  return (
    <>
    <MediaModal modal={modal} setModal={setModal} media={media} tittle={tittle} />
    <div style={{backgroundColor:'#0B22E8'}}>
      <Header
        color="transparent"
        brand="Celebrationjump LDA"
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 300,
          color: "info",
        }}
        {...rest}
      />
      <Parallax filter/>
      <div className={classNames(classes.main, classes.mainRaised)} >
        <div className={classes.container}>
            <div className={classesSection.section}>
                <GridContainer justifyContent="center">
                    <GridItem xs={12} sm={12} md={8}>
                    <h1 className={classesSection.title}>Our Venues</h1>
                    
                    </GridItem>
                </GridContainer>
                    {/* All Our Bars and Venues 1st row */}
                <GridContainer>
                    <GridItem xs={12} sm={12} md={4}>
                        <hr className="text-info bg-info" />
                        <img src={require("assets/img/brand/albufeira66Logo.png").default} width='50%' />
                        <h3>Bar Albufeira 66</h3> 
                        <p className='text-black-50 mb-2'>
                            <strong>Location:</strong> Albufeira(Strip)<br/>
                            <strong>Capacity:</
                            strong> 500pax<br/>
                            <strong>Style:</strong> American Pub<br/>
                            <strong>Schedule:</strong> Mon - Sun  10am - 4am<br/>
                            <strong>About:</strong> Albufeira 66 is an American<br/>
                            styled bar that serves a large<br/>
                            selection of beers, ciders, cocktails<br/>
                            and a lot of fun. <br/>
                        </p>
                        <div className="text-center">
                            <Button
                            onClick={()=> displayMedia('Albufeira 66','albufeira66')}
                            className="mt-4"
                            color="primary"
                            type="button"
                            >
                            Media
                            </Button>
                        </div>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                        <hr className="text-info bg-info" />
                        <img src={require("assets/img/brand/heavenLogo.png").default} width='65%' />
                        <h3>Club Heaven</h3> 
                        <p className='text-black-50 mb-2'>
                            <strong>Location:</strong> Albufeira(Strip)<br/>
                            <strong>Capacity:</strong> 1000pax<br/>
                            <strong>Style:</strong> Nightclub<br/>
                            <strong>Schedule:</strong> Mon - Sun  1am - 6am<br/>
                            <strong>About:</strong> Club Heaven is the best nightclub<br/>
                            located right in the heartof the strip.<br/>
                            The party goes on till the sun comes up<br/>
                            with our resident and guest DJ's.<br/>
                        </p>
                        <div className="text-center">
                            <Button
                            onClick={()=> displayMedia('Club Heaven','heaven')}
                            className="mt-4"
                            color="primary"
                            type="button"
                            >
                            Media
                            </Button>
                        </div>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                        <hr className="text-info bg-info" />
                        <img src={require("assets/img/brand/albufissaLogo.png").default} width='50%' className="mt--4" />
                        <h3 className="mt--4">Albufissa</h3> 
                        <p className='text-black-50 mb-2 '>
                            <strong>Location:</strong> Albufeira(Above Albufeira 66)<br/>
                            <strong>Capacity:</strong> 500pax<br/>
                            <strong>Style:</strong> Feest Cafe<br/>
                            <strong>Schedule:</strong> Mon - Sun  10pm - 4am<br/>
                            <strong>About:</strong> Albufissa is a rooftop bar
                            with a dutch feest cafe style and
                            energy.<br/>
                        </p>
                        <div className="text-center mt-5">
                            <Button
                            onClick={()=> displayMedia('Albufissa Rooftop','albufissa')}
                            className="mt-4"
                            color="primary"
                            type="button"
                            >
                            Media
                            </Button>
                        </div>
                    </GridItem>
                </GridContainer>

                {/* All Our Bars and Venues 2nd row */}
                <GridContainer>
                    <GridItem xs={12} sm={12} md={4}>
                        <hr className="text-info bg-info" />
                        <img src={require("assets/img/brand/heavenWarehouseLogo.png").default} width='50%' className="mt-5 mb-5" />
                        <h3 className="mt-2" >Heaven Warehouse</h3> 
                        <p className='text-black-50 mb-2'>
                            <strong>Location:</strong> Albufeira(Next to Albufeira 66)<br/>
                            <strong>Capacity:</strong> 500pax<br/>
                            <strong>Style:</strong> Warehouse Snack Bar<br/>
                            <strong>Schedule:</strong> Mon - Sun  4am - 1pm<br/>
                            <strong>About:</strong> Heaven Warehouse is a
                            repurposed warehouse where you
                            can grab a drink and a bite to eat
                            in a trendy setting.
                        </p>
                        <div className="text-center mt-5">
                            <Button
                            onClick={()=> displayMedia('Heaven Warehouse','warehouse')}
                            className="mt-1"
                            color="primary"
                            type="button"
                            >
                            Media
                            </Button>
                        </div>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                        <hr className="text-info bg-info" />
                        <img src={require("assets/img/brand/tropicanaLogo.png").default} width='50%' />
                        <h3>Club Tropicana</h3> 
                        <p className='text-black-50 mb-2'>
                            <strong>Location:</strong> Albufeira(At the end of the Strip)<br/>
                            <strong>Capacity:</strong> 500pax<br/>
                            <strong>Style:</strong> Nightclub(Tropical)<br/>
                            <strong>Schedule:</strong> Mon WED Sun  10pm - 4am<br/>
                            <strong>About:</strong> Club Tropicana is a tropical/jungle<br/>
                            themed club. We host all kinds of<br/>
                            themed parties.<br/>
                        </p>
                        <div className="text-center mt-4">
                            <Button
                            onClick={()=> displayMedia('Club Tropicana','tropicana')}
                            className="mt-4"
                            color="primary"
                            type="button"
                            >
                            Media
                            </Button>
                        </div>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                        <hr className="text-info bg-info" />
                        <img src={require("assets/img/brand/poolPartyLogo.png").default} width='50%' className="mt--3 mb-1" />
                        <h3>Pool Party</h3> 
                        <p className='text-black-50 mb-2 '>
                            <strong>Location:</strong> Albufeira(Strip - Heaven's garden)<br/>
                            <strong>Capacity:</strong> 600pax<br/>
                            <strong>Style:</strong> Beach<br/>
                            <strong>Schedule:</strong> TUE - THU - SAT  4pm - 8pm<br/>
                            <strong>About:</strong> The Heaven Pool Party is 1 of <br/>
                            the biggest highlights in Albufeira's.<br/>
                            whether you come for the crazy foam parties<br/>
                            or to relax in 1 of our VIP cabanas.<br/>
                        </p>
                        <div className="text-center mt--2">
                            <Button
                            onClick={()=> displayMedia('Pool Party','pool')}
                            className="mt-4"
                            color="primary"
                            type="button"
                            >
                            Media
                            </Button>
                        </div>
                    </GridItem>
                </GridContainer>

                {/* All Our Bars and Venues 3rd row */}
                <GridContainer>
                    <GridItem xs={12} sm={12} md={4}>
                        {/*<hr className="text-info bg-info" />
                        <img src={require("assets/img/brand/boatPartyLogo.png").default} width='50%' />
                        <h3>Boat Party</h3> 
                        <p className='text-black-50 mb-2'>
                            Location: Albufeira(Depart from Albufeira 66)<br/>
                            Capacity: 180pax<br/>
                            Style: Boat Party<br/>
                            Schedule: Sun  2am - 8pm<br/>
                            About: Our Boat Party departs from<br/>
                            the bar "Albufeira 66 " and from there<br/>
                            on everything is included(transport,<br/>
                            beer, sangria, soft drinks and a BBQ.<br/>
                        </p>*/}
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                        <hr className="text-info bg-info" />
                        <img src={require("assets/img/brand/boatPartyLogo.png").default} width='50%' />
                        <h3>Boat Party</h3> 
                        <p className='text-black-50 mb-2'>
                            <strong>Location:</strong> Albufeira(Depart from Albufeira 66)<br/>
                            <strong>Capacity:</strong> 180pax<br/>
                            <strong>Style:</strong> Boat Party<br/>
                            <strong>Schedule:</strong> Sun  2am - 8pm<br/>
                            <strong>About:</strong> Our Boat Party departs from<br/>
                            the bar "Albufeira 66 " and from there<br/>
                            on everything is included(transport,<br/>
                            beer, sangria, soft drinks and a BBQ.<br/>
                        </p>
                        <div className="text-center mt-5">
                            <Button
                            onClick={()=> displayMedia('Boat Party','boat')}
                            className="mt-4"
                            color="primary"
                            type="button"
                            >
                            Media
                            </Button>
                        </div>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                        {/*<hr className="text-info bg-info" />
                        <img src={require("assets/img/brand/poolPartyLogo.png").default} width='50%' className="mt--4" />
                        <h3 className="mt--4">Club Heaven</h3> 
                        <p className='text-black-50 mb-2 '>
                            Location: Albufeira(Strip - Heaven's garden)<br/>
                            Capacity: 600pax<br/>
                            Style: Beach<br/>
                            Schedule: TUE - THU - SAT  4pm - 8pm<br/>
                            About: The Heaven pool Party is 1 of <br/>
                            the biggest highlights in Albufeira's.<br/>
                            whether you come for the crazy foam parties<br/>
                            or to relax in 1 of our VIP cabanas.<br/>
                        </p>*/}
                    </GridItem>
                </GridContainer>
                
            </div>
        </div>
      </div>
      <Footer />
    </div>
    </>
  )
}

export default Bars